import { useState, useEffect } from 'react';
import { getCookie, setCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';

import { getCookieDomain } from '../utils/cookies';

export function useCookie(key: string, defaultValue?: string) {
  const getItem = () => {
    if (typeof window === 'undefined') return defaultValue;
    const cookieValue = getCookie(key);
    return cookieValue?.toString() || defaultValue;
  };

  const [cookie, setItem] = useState(getItem());

  // Sync with actual cookie changes (e.g., after page reload or external updates)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const syncCookie = () => {
      const cookieValue = getCookie(key);
      const newValue = cookieValue?.toString() || defaultValue;
      if (newValue !== cookie) {
        setItem(newValue);
      }
    };

    // Check immediately
    syncCookie();

    // Set up interval to check for cookie changes
    const intervalId = setInterval(syncCookie, 1000);

    return () => clearInterval(intervalId);
  }, [key, cookie, defaultValue]);

  const updateCookie = (value: any, options: OptionsType = {}) => {
    const domain = options?.domain || getCookieDomain();
    setCookie(key, value, { ...options, domain });
    setItem(value);
  };

  return [cookie, updateCookie] as const;
}
